import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon',
  templateUrl: 'icon.html'
})
export class Icon implements OnInit {

  //Name of the icon
  @Input() name: string;
  //Color of the icon
  @Input() color: string;
  @Input() activeColor: string;
  @Input() hoverColor: string;
  @Input() size: string = '';
  @Input() active: boolean = false;  
  
  classes: string[] = [];

  ngOnInit() {
    
    if (this.name) this.classes.push(this.name);
    if (this.size) this.classes.push(this.size);
    if (this.color) this.classes.push('color color-' + this.color); 
    if (this.activeColor) this.classes.push('active-color-' + this.activeColor);
    if (this.hoverColor) this.classes.push('hover-color-' + this.hoverColor);

  }
}



// WEBPACK FOOTER //
// ./src/partials/icon/icon.ts